// document-state.ts
import { IdentityDocument } from "./identity-models";

export default class DocumentState {
    private documents: IdentityDocument[] = [];

    public addDocument(document: IdentityDocument) {
        // remove old doc for the same category if it exists
        this.documents = this.documents.filter(d => d.docSelectId !== document.docSelectId);
        this.documents.push(document);
    }

    public getAllDocuments(): IdentityDocument[] {
        return this.documents;
    }

    public reset() {
        this.documents = [];
    }

}

